import { CompletedWorkoutActions, CompletedWorkoutsStore } from "features/Workouts/Workouts.types";
import React from "react";

const CompletedWorkoutsContext = React.createContext<[CompletedWorkoutsStore, CompletedWorkoutActions] | undefined>(
  undefined
);
CompletedWorkoutsContext.displayName = "CompletedWorkoutsContext";

export default CompletedWorkoutsContext;
